import React from "react";

import BasicEmailInput from "../../global/textInputs/BasicEmailInput";
import TagButton from "../../global/buttons/TagButton";

import '../../../styles/formBuilder/components/conditional-email-panel.scss'

interface IConditionalEmailWrapper {
    emailTextInput: string;
    setEmailTextInput: (val: string) => void;
    handleAddEmailClick: () => void;
    children?: React.ReactNode;
    title?: string;
    emailRecipientsList: string[],
    removeEmailFromList: (email: string) => void,
    className?: string
}

const ConditionalEmailPanel = ({
    emailTextInput,
    setEmailTextInput,
    handleAddEmailClick,
    children,
    title,
    emailRecipientsList,
    removeEmailFromList,
    className
}: IConditionalEmailWrapper) => {

    return (
        <div className={`conditional-email-wrapper conditional-logic-panel ${className ?? ''}`}>
            {children}
            {title && <h2 className="title">{title}</h2>}
            <div className="recipients-panel">
                {emailRecipientsList.map((email, index) => (
                    <TagButton
                        key={`${email}-${index}`}
                        content={email}
                        closeAriaLabel={`Remove ${email} from recipients`}
                        onButtonClick={() => removeEmailFromList(email)}
                    />
                ))}
            </div>
            <BasicEmailInput
                className="form-settings-email-input"
                id="form-settings-email-input"
                labelText={"Insert Email Address"}
                labelIsHidden
                placeholderText={"E.g. name@company.com"}
                setTextString={setEmailTextInput}
                textString={emailTextInput}
                buttonContent={"Add Email"}
                onButtonClick={handleAddEmailClick}
            />
        </div>
    );
};

export default ConditionalEmailPanel;
